import compilation from "@assets/json/compilation.json";
import { environment } from "@environment/environment";


export const IORTHOPAY_SESSION_KEY = 'iOrthoPay.session';
export const DDO_SESSION_KEY = 'ddo.session';
export const BACKEND_URL = environment.config.apiUrlItek;
export const LAST_DEPLOY = compilation.last_deploy;





